// Salary deduction cycle: 26th of previous month → 25th of current month —
// mirrors backend/src/utils/cycleHelper.js's getCurrentCycle exactly, so the
// frontend's cycle list always lines up with how the backend stamps cycleStart.

export const fmtLocalDate = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export function buildCycles(n = 6) {
  const cycles = [];
  const today  = new Date();
  let year  = today.getFullYear();
  let month = today.getMonth();

  if (today.getDate() < 26) {
    month -= 1;
    if (month < 0) { month = 11; year -= 1; }
  }

  for (let i = 0; i < n; i++) {
    const startDate = new Date(year, month, 26);
    const endDate   = new Date(year, month + 1, 25);
    cycles.push({
      label:      `${startDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} – ${endDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`,
      cycleStart: fmtLocalDate(startDate),
      isCurrent:  i === 0,
    });
    month -= 1;
    if (month < 0) { month = 11; year -= 1; }
  }
  return cycles;
}
